import Link from '@/atoms/Link/Link'
import categories, { STANDALONE_CATEGORY_PAGES } from '@/utils/enums/categories'

import { ReactComponent as ArrowIcon } from 'public/assets/icons/chevron-right.svg'

const CategorySelection = () => {
  return (
    <section className="container | font-heading | py-5 md:py-9">
      <h4 className="text-3xl lg:text-4xl font-semibold capitalize | mb-5">
        Explore more topics
      </h4>
      <p className="font-body text-sm lg:text-xl text-gray-60 | mb-12">
        Looking for guides, articles or something more specific? Browse all our
        posts by topics
      </p>

      <div className="flex flex-wrap gap-6">
        {Object.values(categories).map(category => {
          if (!category || !category.isFeatured) return
          const linkPrefix = category.slug.startsWith('http')
            ? ''
            : STANDALONE_CATEGORY_PAGES.includes(category.slug)
            ? '/'
            : '/blog/category/'

          return (
            <Link
              key={category.slug}
              href={`${linkPrefix}${category.slug}/`}
              className="flex grow lg:grow-0 justify-center lg:justify-start gap-3 items-center | text-blue-web-90 font-semibold hover:text-white bg-orange-10 hover:bg-orange-50 transition-colors duration-200 ease-in-out | rounded-lg  p-5"
            >
              <span>{category.name}</span>
              <ArrowIcon />
            </Link>
          )
        })}
      </div>
    </section>
  )
}

export default CategorySelection
